import { render, staticRenderFns } from "./PagePlansAlimentaires.vue?vue&type=template&id=e172631c&scoped=true&"
import script from "./PagePlansAlimentaires.vue?vue&type=script&lang=js&"
export * from "./PagePlansAlimentaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e172631c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e172631c')) {
      api.createRecord('e172631c', component.options)
    } else {
      api.reload('e172631c', component.options)
    }
    module.hot.accept("./PagePlansAlimentaires.vue?vue&type=template&id=e172631c&scoped=true&", function () {
      api.rerender('e172631c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Menus/PagePlansAlimentaires.vue"
export default component.exports